import React, { useState, useEffect, useCallback } from "react";
import { timestampConversion } from "utils/common";
import moment from "moment";
import { dailyIntakeAndRecallTableColumns } from "utils/tablesHeaderContent";
import AdminClientInfoCard from "containers/clientDetails/sub-components/card/adminClientCard";
import { dailyIntakeAndRecallRow } from "containers/clientDetails/sub-components/common/dailyIntakeAndRecallTableRows";
import DailyIntakeModal from "containers/clientDetails/sub-components/modal/dailyIntake";
import DefaultModal from "containers/clientDetails/sub-components/modalContainer/default";
import { headerDesc } from "utils/helper";
import * as XLSX from "xlsx";

function DailyIntakeForm({
  id,
  setSelectedClient,
  dailyIntakeArray,
  title,
  deleteHandler,
}) {
  const [rows, setRows] = useState([]);
  const columns = [...dailyIntakeAndRecallTableColumns];
  const [newIntakeModal, setNewIntakeModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState(null);
  const [mode, setMode] = useState("view");

  const addHandler = useCallback(() => {
    setSelectedItem(null);
    setMode("create");
    setNewIntakeModal(true);
  }, []);

  const editHandler = useCallback((item) => {
    setSelectedItem(item);
    setMode("edit");
    setNewIntakeModal(true);
  }, []);

  const viewHandler = useCallback((item) => {
    setSelectedItem(item);
    setMode("view");
    setNewIntakeModal(true);
  }, []);

  useEffect(() => {
    const convertTimestamp = (timestamp) => {
      return timestamp?.seconds
        ? moment(timestampConversion(timestamp))
        : moment(timestamp);
    };

    let dailyFoodIntakeArray = dailyIntakeArray.slice();

    dailyFoodIntakeArray.sort((a, b) => {
      const a_timestamp = convertTimestamp(a?.timestamp);
      const b_timestamp = convertTimestamp(b?.timestamp);
      return b_timestamp - a_timestamp;
    });

    setRows(
      dailyIntakeAndRecallRow(
        dailyFoodIntakeArray,
        editHandler,
        viewHandler,
        deleteHandler,
        "dailyIntake"
      )
    );
  }, [dailyIntakeArray, editHandler, viewHandler]);

  const downloadBtnClickHandler = () => {
    let updatedData = dailyIntakeArray.map((item, index) => {
      let updatedAt = item?.timestamp?.seconds
        ? moment(timestampConversion(item?.timestamp))
            .local()
            .format("MMMM Do YYYY, h:mm a")
        : moment(item?.timestamp).local().format("MMMM Do YYYY, h:mm a");

      let createdAt = item?.createdAt?.seconds
        ? moment(timestampConversion(item?.createdAt))
            .local()
            .format("MMMM Do YYYY, h:mm a")
        : moment(item?.createdAt).local().format("MMMM Do YYYY, h:mm a");
        

      const meals = [
        "earlyMorning",
        "breakfast",
        "midMorning",
        "brunch",
        "midMeal",
        "lunch",
        "postLunch",
        "evening",
        "beforeDinner",
        "dinner",
        "postDinner",
        "lateNight",
      ];

      let mealData = meals.map((meal) => {
        return `${item?.[meal]?.clientAte ?? "N/A"} at ${
          item?.[meal]?.time ?? "N/A"
        }`;
      });

      return [
        index + 1,
        createdAt,
        updatedAt,
        item?.dietType ?? "N/A",
        item?.frequencyOfEating ?? "N/A",
        item?.waterIntake ?? "N/A",
        ...mealData,
      ];
    });

    let excelData = [
      [
        "ID",
        "Created At",
        "Updated At",
        "Diet Type",
        "Frequency of Eating",
        "Water Intake",
        "Early Morning",
        "Breakfast",
        "Mid Morning",
        "Brunch",
        "Mid Meal",
        "Lunch",
        "Post Lunch",
        "Evening",
        "Before Dinner",
        "Dinner",
        "Post Dinner",
        "Late Night",
      ],
      ...updatedData,
    ];

    let workbook = XLSX.utils.book_new();
    let worksheet = XLSX.utils.aoa_to_sheet(excelData);
    XLSX.utils.book_append_sheet(workbook, worksheet, "Diet & Meal Data");
    XLSX.writeFile(workbook, "Daily_intake.xlsx");
  };
  return (
    <>
      <AdminClientInfoCard
        title={title}
        onClickBtnHandler={addHandler}
        columns={columns}
        rows={rows}
        downloadButton
        downloadBtnClickHandler={downloadBtnClickHandler}
      />
      <DefaultModal
        open={newIntakeModal}
        {...headerDesc(mode, "Client's Daily Intake", selectedItem)}
        handleCloseModal={() => {
          setNewIntakeModal(false);
          setSelectedItem(null);
        }}
        mode={mode}
        setMode={setMode}
      >
        <DailyIntakeModal
          id={id}
          persona="admin"
          mode={mode}
          open={newIntakeModal}
          setSelectedClient={setSelectedClient}
          selectedItem={selectedItem}
          setSelectedItem={setSelectedItem}
          handleCloseModal={() => {
            setNewIntakeModal(false);
            setSelectedItem(null);
          }}
        />
      </DefaultModal>
    </>
  );
}

export default DailyIntakeForm;
